import { render, staticRenderFns } from "./StatisticsTableChart.vue?vue&type=template&id=5d703ea4&"
import script from "./StatisticsTableChart.vue?vue&type=script&lang=js&"
export * from "./StatisticsTableChart.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTableChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports